import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import TableTitle from "../../../../common/list/components/TableTitle";
import CommonList from "../../../../common/list";
import {columns} from "./items/column";
import {
    deleteSettingLocation,
    loadSettingLocations,
    updateStatusSettingLocation
} from "../../../../api/hrm/timekeeping/time-sheet/location";
import TableMenu from "../../../../common/list/components/TableMenu";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {font_icon} from "../../../../common/column";
import {Modal, Switch} from "antd";
import {loadTimekeepingCommonConfigApi, updateAttendance} from "../../../../api/setting/timekeeping";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";
import uuid from "draft-js/lib/uuid";
import {optionBoundingBox} from "./items/InputRadius";
import {formatCurrency} from "../../../../format/Money";

const AttendanceLocations = props => {

    const [dataSource, setDataSource] = useState()
    const [totalCount, setTotalCount] = useState()
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {filter, search, reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [searchParams] = useSearchParams();
    const sort = searchParams.get("sort")
    const page = searchParams.get("page");
    const pageSize = searchParams.get("pageSize");
    const [loading, setLoading] = useState(true);
    let navigate = useNavigate();
    const [defaultConfigGps, setDefaultConfigGps] = useState(undefined)

    useEffect(() => {
        loadTimekeepingCommonConfigApi().then(res => {
            setDefaultConfigGps(res?.attendanceGPS)
        })
    }, []);

    function handleOnDelete(id, item) {
        Modal.confirm({
            title: t("tnp.setting.deleteLocation"),
            content: <p>{t("common.message.deleteAsk")}  </p>,
            icon: null,
            width: 500,
            onOk: () => {
                return deleteSettingLocation(id).then(response => {
                    getDataSource();
                })
            },

            autoFocusButton: null,
            closable: true,
            maskClosable: false,
            okText: t("tnp.button.delete"),
            cancelText: t("tnp.button.cancelText")
        })
    }
    function mapDataSource(values) {
        return values?.map(item => (

            {
                ...item,
                type : (item?.type === "radius" || item?.type === undefined || item?.type === null) ? `${formatCurrency(item?.radius)} (m)` :
                    (optionBoundingBox(t)?.find(o => o.value === item?.boundingBox)?.label || t("tnp.setting.province")),
                key: uuid(),
                status: <Switch defaultChecked={item?.status || false}

                                onClick={(sw) => {
                                    if(sw && !defaultConfigGps && item?.id){
                                        Modal.confirm({
                                            title: t("tnp.setting.disableGps"),
                                            content: <p  dangerouslySetInnerHTML={{
                                                __html:  t("tnp.setting.enableGps",{name : `<span class="font-bold">${item?.name}</span>` })
                                            }} />,
                                            icon: null,
                                            width: 500,
                                            onOk: () => {
                                                updateAttendance(true).then(response => {
                                                    setDefaultConfigGps(true)
                                                    updateStatusSettingLocation(item.id,sw).then(response => {
                                                        dispatch(onReloadData(!reloadData))
                                                    })
                                                })
                                            },
                                            onCancel : () => {
                                                dispatch(onReloadData(!reloadData))
                                            },
                                            autoFocusButton: null,
                                            closable: true,
                                            maskClosable: false,
                                            okText: t("common.agree"),
                                            cancelText: t("tnp.button.cancelText")
                                        })
                                    }
                                    else {
                                        updateStatusSettingLocation(item.id,sw).then(response => {
                                            dispatch(onReloadData(!reloadData))
                                        })
                                    }

                                }}/>,
                statusValue: item?.status,
                menu: <TableMenu
                    items={[

                        {
                            key: "update",
                            originalIcon: <EditOutlined style={{fontSize: font_icon}}/>,
                            onClick: () => navigate(`/setting/timekeeping/attendance-locations/update/${item.id}`),
                            hint: t("tnp.button.update"),
                        },
                        {
                            key: "delete",
                            originalIcon: <DeleteOutlined style={{fontSize: font_icon}}/>,
                            hint: t("tnp.button.delete"),
                            onClick: () => handleOnDelete(item.id, item),
                        },
                    ].filter(item => !item.hidden)}
                />
            }

        ))
    }

    function getDataSource(filter, page, pageSize, search, sort) {
        setLoading(true);
        let _search = undefined;
        if (search && search !== '') {
            _search = search
        }
        const defaultSort = "createDate:desc";
        loadSettingLocations(
            {
                page: page || 1,
                pageSize: pageSize || 20,
                sort: `${sort || defaultSort}`,
                search: _search,
                filter
            },
        ).then(response => {
                setDataSource(mapDataSource(response.items))
                setTotalCount(response?.totalCount)
            }
        ).finally(() => setLoading(false))


    }

    useEffect(() => {
        if(defaultConfigGps !== undefined ) {
            getDataSource(filter, page, pageSize, search, sort);
        }
    }, [reloadData, filter, search, page, pageSize, sort,defaultConfigGps])

    return (
        <div style={{height: "100%"}}>
            {
                <>
                    <TableTitle
                        title={t("tnp.setting.locationList")}

                    />
                    <CommonList
                        columns={columns}
                        dataSource={dataSource}
                        loading={loading}
                        totalCount={totalCount}
                        rowClassName={(record) => {
                            return   !record.statusValue && "disabled-row";
                        }}
                    />
                </>
            }
        </div>
    );
};

AttendanceLocations.propTypes = {};

export default AttendanceLocations;
